document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-lmdl-copy-code]');
  if (!button) return;

  const code = button.dataset.lmdlCopyCode || '';
  if (!code) return;

  const defaultLabel = button.dataset.defaultLabel || 'Copier';
  const copiedLabel = button.dataset.copiedLabel || 'Copié';

  try {
    await navigator.clipboard.writeText(code);
    button.textContent = copiedLabel;
    window.clearTimeout(button._lmdlCopyTimer);
    button._lmdlCopyTimer = window.setTimeout(() => {
      button.textContent = defaultLabel;
    }, 1800);
  } catch (_) {
    button.textContent = code;
  }
});
